var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1996_41704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 18.75C20 19.4404 19.4404 20 18.75 20H1.25C0.559648 20 0 19.4404 0 18.75V1.25C0 0.559648 0.559648 0 1.25 0C1.94035 0 2.5 0.559648 2.5 1.25V17.5H18.75C19.4404 17.5 20 18.0596 20 18.75ZM6.0275 15.6132C6.71785 15.6132 7.2775 15.0535 7.2775 14.3632V10.0022C7.2775 9.31188 6.71785 8.75223 6.0275 8.75223C5.33715 8.75223 4.7775 9.31188 4.7775 10.0022V14.3632C4.7775 15.0535 5.33715 15.6132 6.0275 15.6132ZM11.7696 15.6132C12.46 15.6132 13.0196 15.0535 13.0196 14.3632V6.44332C13.0196 5.75297 12.46 5.19332 11.7696 5.19332C11.0793 5.19332 10.5196 5.75297 10.5196 6.44332V14.3632C10.5196 15.0535 11.0793 15.6132 11.7696 15.6132ZM17.5118 15.6132C18.2022 15.6132 18.7618 15.0535 18.7618 14.3632V3.08387C18.7618 2.39352 18.2022 1.83387 17.5118 1.83387C16.8215 1.83387 16.2618 2.39352 16.2618 3.08387V14.3632C16.2618 15.0535 16.8215 15.6132 17.5118 15.6132Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1996_41704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.5ad6e919726edc928d43b79d9ca23265.svg";
export { ForwardRef as ReactComponent };